import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { gendersDataSource } from 'infrastructure/data-sources/genders';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { IGenderItem } from 'infrastructure/data-sources/genders';

type Options = IBaseSelectBoxOption<IGenderItem['id'], IGenderItem>[];

interface IGenderSelectBoxProps extends Omit<IBaseSelectBoxProps, 'options'> {}

const GenderSelectBox: React.FC<IGenderSelectBoxProps> = (props) => {
  const dataSource = useMemo(() => gendersDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default GenderSelectBox;
